import React, { useState, useEffect } from 'react';
import { Card, Table, Select, message } from 'antd';
import { customerApi, shipmentApi, type CustomerDTO, type ShipmentDTO } from '../api/kfc';
import { serverTablePagination } from '../utils/tablePagination';

const CustomerShipments: React.FC = () => {
  const [customers, setCustomers] = useState<CustomerDTO[]>([]);
  const [selectedCode, setSelectedCode] = useState<string | undefined>();
  const [list, setList] = useState<ShipmentDTO[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  useEffect(() => {
    customerApi.list()
      .then((res) => setCustomers(res.data))
      .catch(() => { setCustomers([]); message.warning('无法加载客户列表'); });
  }, []);

  useEffect(() => {
    if (!selectedCode) {
      setList([]);
      setTotal(0);
      return;
    }
    setLoading(true);
    shipmentApi.list({ clientCode: selectedCode, page, size: pageSize })
      .then((res: { data: { content: ShipmentDTO[]; totalElements: number } }) => {
        setList(res.data.content || []);
        setTotal(res.data.totalElements ?? 0);
      })
      .catch(() => { setList([]); setTotal(0); })
      .finally(() => setLoading(false));
  }, [selectedCode, page, pageSize]);

  return (
    <Card title="客户运单">
      <Select
        placeholder="选择客户"
        allowClear
        style={{ width: 260, marginBottom: 16 }}
        options={customers.map((c) => ({ label: `${c.customerCode} - ${c.name}`, value: c.customerCode }))}
        value={selectedCode}
        onChange={(v) => { setSelectedCode(v); setPage(0); }}
      />
      <Table
        loading={loading}
        dataSource={list}
        rowKey="shipmentId"
        columns={[
          { title: '运单号', dataIndex: 'shipmentId', width: 200 },
          { title: '客户', dataIndex: 'clientCode', width: 100 },
          { title: '运输方式', dataIndex: 'transportMode', width: 100, render: (v: string) => v || '-' },
          { title: '线路', dataIndex: 'routeName', width: 120 },
          { title: '状态', dataIndex: 'status', width: 140 },
          { title: '计费重(kg)', dataIndex: 'confirmedWeight', width: 100 },
        ]}
        pagination={serverTablePagination({
          page,
          pageSize,
          total,
          onPageChange: setPage,
          onPageSizeChange: setPageSize,
        })}
      />
    </Card>
  );
};

export default CustomerShipments;
